export default __webpack_public_path__ + "static/media/general2024RealCase1-sc.315b6226.jpg";